<template>
    <div class="main">
        <!-- 新增功能模态框 -->
        <div class="addFrom">
            <el-dialog
                :title="openData.title"
                :visible="openData.state"
                width="990px"
                :before-close="handleClose"
            >
                <div class="addDialogTabs">
                    <div
                        v-for="(item, index) in dialogTabs"
                        :key="index"
                        :class="{ borderBot: borderBotKey == index }"
                        @click="selectDialogTabs(index)"
                    >
                        {{ item }}
                    </div>
                </div>
                <el-form
                    ref="addForm1"
                    :model="addForm"
                    :rules="addFormRules1"
                    v-show="dialogBox == 0"
                    label-width="100px"
                >
                    <div class="dialogBody">
                        <el-row :gutter="24">
                            <el-col :span="9">
                                <el-form-item
                                    label="姓名："
                                    prop="customerName"
                                >
                                    <el-input
                                        v-model="addForm.customerName"
                                        readonly
                                        :disabled="openData.title == '查看'"
                                    >
                                        <el-button
                                            slot="append"
                                            :disabled="openData.title == '查看'"
                                            icon="el-icon-search"
                                            @click="lookRY"
                                            style="margin-left: -15px"
                                        ></el-button>
                                    </el-input>
                                </el-form-item>
                                <el-form-item
                                    label="性别："
                                    prop="customerSex"
                                    style="margin-top: 20px"
                                >
                                    <el-select
                                        v-model="addForm.customerSex"
                                        placeholder=""
                                        :disabled="
                                            openData.title == '查看' ||
                                            openData.title == '新增'
                                        "
                                        style="width: 100%"
                                    >
                                        <el-option
                                            v-for="item in sexOptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item
                                    label="民族："
                                    prop="nation"
                                    style="margin-top: 20px"
                                >
                                    <el-select
                                        v-model="addForm.nation"
                                        :disabled="
                                            openData.title == '查看' ||
                                            openData.title == '新增'
                                        "
                                        placeholder=""
                                        style="width: 100%"
                                    >
                                        <el-option
                                            v-for="item in nation"
                                            :key="item"
                                            :label="item"
                                            :value="item"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item
                                    label="手机号码："
                                    prop="customerPhone"
                                    style="margin-top: 20px"
                                >
                                    <el-input
                                        v-model="addForm.customerPhone"
                                        :disabled="
                                            openData.title == '查看' ||
                                            openData.title == '新增'
                                        "
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="人员编号："
                                    style="margin-top: 20px"
                                    prop="faceIdcode"
                                >
                                    <el-input
                                        v-model="addForm.faceIdcode"
                                        :disabled="
                                            openData.title == '查看' ||
                                            openData.title == '新增'
                                        "
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="9">
                                <el-form-item
                                    label="身份证号："
                                    prop="customerIdcard"
                                >
                                    <el-input
                                        v-model="addForm.customerIdcard"
                                        :disabled="
                                            openData.title == '查看' ||
                                            openData.title == '新增'
                                        "
                                        @change="searchPerson"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="出生年月："
                                    prop="customerBirthday"
                                    style="margin-top: 20px"
                                >
                                    <el-date-picker
                                        v-model="addForm.customerBirthday"
                                        type="date"
                                        placeholder="选择日期"
                                        :disabled="
                                            openData.title == '查看' ||
                                            openData.title == '新增'
                                        "
                                        value-format="yyyy-MM"
                                        style="width: 100%"
                                    >
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item
                                    label="年龄："
                                    prop="customerAge"
                                    style="margin-top: 20px"
                                >
                                    <el-input
                                        v-model="addForm.customerAge"
                                        :disabled="
                                            openData.title == '查看' ||
                                            openData.title == '新增'
                                        "
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="政治面貌："
                                    prop="customerPolitical"
                                    style="margin-top: 20px"
                                >
                                    <el-select
                                        v-model="addForm.customerPolitical"
                                        :disabled="
                                            openData.title == '查看' ||
                                            openData.title == '新增'
                                        "
                                        placeholder="政治面貌"
                                    >
                                        <el-option
                                            label="中共党员"
                                            value="0"
                                        ></el-option>
                                        <el-option
                                            label="共青团员"
                                            value="1"
                                        ></el-option>
                                        <el-option
                                            label="群众"
                                            value="2"
                                        ></el-option>
                                        <el-option
                                            label="其他"
                                            value="3"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>

                                <el-form-item
                                    label="组织机构："
                                    style="height: 40px; margin-top: 20px"
                                    prop="orgName"
                                >
                                    <el-select
                                        style="width: 100%"
                                        class="marginT34"
                                        v-model="addForm.orgName"
                                        placeholder="请选择组织机构"
                                        ref="selectBoxRef"
                                        :disabled="
                                            openData.title == '查看' ||
                                            openData.title == '新增'
                                        "
                                    >
                                        <el-option
                                            :value="addForm.orgName"
                                            style="height: auto"
                                        >
                                            <el-tree
                                                :data="orgList"
                                                :props="defaultProps"
                                                ref="tree"
                                                @node-click="
                                                    handleEditNodeClick
                                                "
                                                class="tree_box"
                                            ></el-tree>
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item
                                    prop="customerPhoto"
                                    label-width="0px"
                                >
                                    <el-upload
                                        :disabled="
                                            openData.title == '查看' ||
                                            openData.title == '新增'
                                        "
                                        :show-file-list="false"
                                        :action="actionUrl"
                                        list-type="picture-card"
                                        :limit="1"
                                        :on-success="
                                            (file, fileList) => {
                                                handleAvatarSuccess(
                                                    file,
                                                    fileList,
                                                    'add'
                                                )
                                            }
                                        "
                                        :before-upload="beforeAvatarUpload"
                                        :on-preview="handlePicturePreview"
                                        :on-exceed="handleExceed"
                                    >
                                        <img
                                            v-if="addForm.customerPhoto"
                                            :src="addForm.customerPhoto"
                                            class="avatar"
                                        />
                                        <i
                                            v-else
                                            class="
                                                el-icon-plus
                                                avatar-uploader-icon
                                            "
                                        ></i>
                                    </el-upload>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                    <el-form-item
                        label="居住情况："
                        prop="customerJzqk"
                        style="display: contents"
                    >
                        <el-radio
                            v-model="addForm.customerJzqk"
                            label="1"
                            :disabled="
                                openData.title == '查看' ||
                                openData.title == '新增'
                            "
                            >独自居住
                        </el-radio>
                        <el-radio
                            v-model="addForm.customerJzqk"
                            label="2"
                            :disabled="
                                openData.title == '查看' ||
                                openData.title == '新增'
                            "
                            >与配偶居住
                        </el-radio>
                        <el-radio
                            v-model="addForm.customerJzqk"
                            label="3"
                            :disabled="
                                openData.title == '查看' ||
                                openData.title == '新增'
                            "
                            >与子女居住
                        </el-radio>
                        <el-radio
                            v-model="addForm.customerJzqk"
                            label="4"
                            :disabled="
                                openData.title == '查看' ||
                                openData.title == '新增'
                            "
                            >其他
                        </el-radio>
                    </el-form-item>
                    <el-form-item
                        label="经济来源："
                        prop="economySource"
                        style="display: contents"
                    >
                        <el-checkbox-group
                            v-model="addForm.economySource"
                            :disabled="
                                openData.title == '查看' ||
                                openData.title == '新增'
                            "
                        >
                            <el-checkbox label="0">养老金</el-checkbox>
                            <el-checkbox label="1">子女供养</el-checkbox>
                            <el-checkbox label="2">救济优抚</el-checkbox>
                            <el-checkbox label="3">兼职</el-checkbox>
                            <el-checkbox label="4">其他</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <div class="dialogBody mb24">
                        <el-form-item label="居住地址：">
                            <el-button
                                type="danger"
                                icon="el-icon-location-outline"
                                @click="location"
                                >定位到标准地址
                            </el-button>
                        </el-form-item>
                    </div>
                    <el-form-item label="" v-if="mapshow">
                        <el-row>
                            <el-col :span="4">
                                <el-form-item>
                                    <el-select
                                        v-model="addForm.provinceId"
                                        disabled
                                        placeholder="请选择省"
                                        @change="handleProvince"
                                        style="width: 100%"
                                    >
                                        <el-option
                                            v-for="(
                                                item, index
                                            ) in provinceList"
                                            :key="index"
                                            :label="item.name"
                                            :value="item.adcode"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4" :offset="1">
                                <el-select
                                    v-model="addForm.cityid"
                                    disabled
                                    placeholder="请选择市"
                                    @change="handleCity"
                                    style="width: 100%"
                                >
                                    <el-option
                                        v-for="(item, index) in cityList"
                                        :key="index"
                                        :label="item.name"
                                        :value="item.adcode"
                                    >
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="4" :offset="1">
                                <el-select
                                    v-model="addForm.zoneid"
                                    disabled
                                    placeholder="请选择区"
                                    @change="handleArea"
                                    style="width: 100%"
                                >
                                    <el-option
                                        v-for="(item, index) in areaList"
                                        :key="index"
                                        :label="item.name"
                                        :value="item.adcode"
                                    >
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="4" :offset="1">
                                <el-select
                                    disabled
                                    v-model="addForm.streetid"
                                    placeholder="请选择街道"
                                    @change="streetChange"
                                >
                                    <el-option
                                        v-for="(item, index) in streetList"
                                        :key="index"
                                        :label="item.addName"
                                        :value="item.addCode"
                                    >
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="4" :offset="1">
                                <el-select
                                    v-model="addForm.shequid"
                                    disabled
                                    placeholder="请选择社区"
                                >
                                    <el-option
                                        v-for="item in communityList"
                                        :key="item.id"
                                        :label="item.address"
                                        :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                            </el-col>
                        </el-row>
                        <el-input
                            v-model.trim="addForm.customerAddress"
                            disabled
                            style="margin-top: 12px; margin-bottom: 12px"
                            placeholder="请在地图的边界内点击选择详细信息"
                        ></el-input>
                        <div class="map_container">
                            <div
                                class="map_right"
                                id="container"
                                style="width: 100%; height: 300px"
                            ></div>
                        </div>
                    </el-form-item>
                </el-form>
                <el-form
                    ref="addForm2"
                    :model="addForm"
                    v-show="dialogBox == 1"
                    label-width="130px"
                    :rules="twoFromRules"
                >
                    <el-form-item
                        label="订餐方式："
                        prop="orderWay"
                        width="100%"
                    >
                        <el-radio
                            v-model="addForm.orderWay"
                            :label="'0'"
                            :disabled="openData.title == '查看'"
                            >按月
                        </el-radio>
                        <el-radio
                            v-model="addForm.orderWay"
                            :label="'1'"
                            :disabled="openData.title == '查看'"
                            >按次
                        </el-radio>
                    </el-form-item>
                    <el-form-item
                        label="订餐开始时间"
                        prop="orderStartTime"
                        v-if="addForm.orderWay == 0"
                    >
                        <el-row :gutter="20" style="display: flex">
                            <el-col :span="20">
                                <el-date-picker
                                    :disabled="openData.title == '查看'"
                                    v-model="addForm.orderStartTime"
                                    type="date"
                                    size="small"
                                    value-format="yyyy-MM-dd"
                                    style="width: 100%"
                                >
                                </el-date-picker>
                            </el-col>
                            <el-col :span="4">
                                <span></span>
                            </el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item
                        label="订餐结束时间"
                        prop="orderEndTime"
                        v-if="addForm.orderWay == '0'"
                    >
                        <el-row :gutter="20" style="display: flex">
                            <el-col :span="20">
                                <el-date-picker
                                    :disabled="openData.title == '查看'"
                                    v-model="addForm.orderEndTime"
                                    value-format="yyyy-MM-dd"
                                    type="date"
                                    size="small "
                                    style="width: 100%"
                                ></el-date-picker>
                            </el-col>
                            <el-col :span="4">
                                <span></span>
                            </el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item
                        label="订餐日期:"
                        prop="orderTimeOnec"
                        v-if="addForm.orderWay == '1'"
                    >
                        <el-row :gutter="20" style="display: flex">
                            <el-col :span="20">
                                <el-date-picker
                                    type="dates"
                                    :disabled="openData.title == '查看'"
                                    style="width: 100%"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                    v-model="addForm.orderTimeOnec"
                                    placeholder="选择一个或多个日期"
                                >
                                </el-date-picker>
                            </el-col>
                            <el-col :span="4">
                                <span></span>
                            </el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item
                        label="订餐类型："
                        prop="orderType"
                        style="margin-top: 10px"
                    >
                        <el-checkbox-group
                            v-model="addForm.orderType"
                            :disabled="openData.title == '查看'"
                        >
                            <el-checkbox label="1">早餐</el-checkbox>
                            <el-checkbox label="2">午餐</el-checkbox>
                            <el-checkbox label="3">晚餐</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="金额：" prop="orderMoney">
                        <el-row :gutter="20" style="display: flex">
                            <el-col :span="20">
                                <el-input
                                    :disabled="openData.title == '查看'"
                                    v-model="addForm.orderMoney"
                                    size="small"
                                    width="100%"
                                    placeholder="获取补贴金额"
                                ></el-input>
                            </el-col>
                            <el-col :span="4"
                                ><span @click="addVolunteer"
                                    >查看详情</span
                                ></el-col
                            >
                        </el-row>
                    </el-form-item>
                    <el-form-item label="余额：" prop="totalMoney">
                        <el-row :gutter="20" style="display: flex">
                            <el-col :span="20">
                                <el-input
                                    disabled
                                    v-model="addForm.totalMoney"
                                    size="small"
                                    width="100%"
                                    placeholder="获取余额"
                                ></el-input>
                            </el-col>
                            <el-col :span="4">
                                <span></span>
                            </el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item
                        label="取餐方式："
                        prop="takeWay"
                        @change.native="showAddress"
                    >
                        <el-radio
                            v-model="addForm.takeWay"
                            label="0"
                            :disabled="openData.title == '查看'"
                            >送餐
                        </el-radio>
                        <el-radio
                            v-model="addForm.takeWay"
                            label="1"
                            :disabled="openData.title == '查看'"
                            >堂食
                        </el-radio>
                        <el-radio
                            v-model="addForm.takeWay"
                            label="2"
                            :disabled="openData.title == '查看'"
                            >自取
                        </el-radio>
                    </el-form-item>
                    <el-form-item
                        label="地址是否正确："
                        prop="isAddress"
                        v-if="showad"
                        required
                    >
                        <el-radio
                            v-model="addForm.isAddress"
                            label="0"
                            :disabled="openData.title == '查看'"
                            >是
                        </el-radio>
                        <el-radio
                            v-model="addForm.isAddress"
                            label="1"
                            :disabled="openData.title == '查看'"
                            >否
                        </el-radio>
                    </el-form-item>
                    <el-form-item label="居住地址：" v-if="showad" required>
                        <el-row>
                            <el-col :span="4">
                                <el-form-item>
                                    <el-select
                                        v-model="addForm.provinceId"
                                        placeholder="请选择省"
                                        :disabled="
                                            normalInfo.orgLevel == 1 ||
                                            normalInfo.orgLevel == 2 ||
                                            normalInfo.orgLevel == 3 ||
                                            normalInfo.orgLevel == 4 ||
                                            normalInfo.orgLevel == 5 ||
                                            openData.title == '查看'
                                        "
                                        @change="handleProvince"
                                        style="width: 100%"
                                    >
                                        <el-option
                                            v-for="(
                                                item, index
                                            ) in provinceList"
                                            :key="index"
                                            :label="item.name"
                                            :value="item.adcode"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4" :offset="1">
                                <el-select
                                    v-model="addForm.cityid"
                                    placeholder="请选择市"
                                    @change="handleCity"
                                    :disabled="
                                        normalInfo.orgLevel == 2 ||
                                        normalInfo.orgLevel == 3 ||
                                        normalInfo.orgLevel == 4 ||
                                        normalInfo.orgLevel == 5 ||
                                        openData.title == '查看'
                                    "
                                    style="width: 100%"
                                >
                                    <el-option
                                        v-for="(item, index) in cityList"
                                        :key="index"
                                        :label="item.name"
                                        :value="item.adcode"
                                    >
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="4" :offset="1">
                                <el-select
                                    v-model="addForm.zoneid"
                                    placeholder="请选择区"
                                    :disabled="
                                        normalInfo.orgLevel == 3 ||
                                        normalInfo.orgLevel == 4 ||
                                        normalInfo.orgLevel == 5 ||
                                        openData.title == '查看'
                                    "
                                    @change="handleArea"
                                    style="width: 100%"
                                >
                                    <el-option
                                        v-for="(item, index) in areaList"
                                        :key="index"
                                        :label="item.name"
                                        :value="item.adcode"
                                    >
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="4" :offset="1">
                                <el-select
                                    v-model="addForm.streetid"
                                    placeholder="请选择街道"
                                    :disabled="
                                        normalInfo.orgLevel == 4 ||
                                        normalInfo.orgLevel == 5 ||
                                        openData.title == '查看'
                                    "
                                    @change="streetChange"
                                >
                                    <el-option
                                        v-for="(item, index) in streetList"
                                        :key="index"
                                        :label="item.addName"
                                        :value="item.addCode"
                                    >
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="4" :offset="1">
                                <el-select
                                    v-model="addForm.shequid"
                                    :disabled="
                                        normalInfo.orgLevel == 5 ||
                                        openData.title == '查看'
                                    "
                                    placeholder="请选择社区"
                                >
                                    <el-option
                                        v-for="item in communityList"
                                        :key="item.id"
                                        :label="item.address"
                                        :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                            </el-col>
                        </el-row>
                        <el-input
                            v-model.trim="addForm.customerAddress"
                            :disabled="openData.title == '查看'"
                            style="margin-top: 12px; margin-bottom: 12px"
                            placeholder=""
                        ></el-input>
                        <!-- :disabled="true" -->
                    </el-form-item>
                    <el-form-item
                        label="部门："
                        prop="departmentId"
                        v-if="showad"
                    >
                        <el-select
                            :disabled="openData.title == '查看'"
                            v-model="addForm.departmentId"
                            placeholder="请选择"
                            size="mini"
                            style="width: 100%"
                            @change="selectDepart"
                        >
                            <el-option
                                v-for="item in subsidyLevelOptions"
                                :key="item.value"
                                :label="item.departmentName"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        label="送餐人员："
                        prop="personId"
                        v-if="showad"
                    >
                        <el-select
                            :disabled="openData.title == '查看'"
                            v-model="addForm.personId"
                            placeholder="请选择"
                            size="mini"
                            style="width: 100%"
                        >
                            <el-option
                                v-for="item in personIdOptions"
                                :key="item.value"
                                :label="item.personName"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div slot="footer" v-if="openData.title != '查看'">
                    <el-button type="primary" @click="submitForm"
                        >确定
                    </el-button>
                    <el-button @click="cancleForm">取消</el-button>
                </div>
            </el-dialog>
        </div>
        <open-info
            v-if="infoVisivle"
            :openData="openData"
            :formData="addForm"
            :allPrice.sync="allPrice"
            @cancleOpen="cancleOrder"
            ref="dcRecords"
        ></open-info>
        <person-open
            v-if="personVisible"
            :openData="personInfo"
            @cancleOpen="canclePerson"
            :value.sync="getUserInfo"
        ></person-open>
    </div>
</template>
<script>
import common from "@/utils/common.js"
import request from "@/utils/request.js"
import baseURL from "@/api/baseURL"
import openInfo from "./openInfo"
import personOpen from "./personOpen"

export default {
    props: ["openData"],
    components: { openInfo, personOpen },
    data() {
        return {
            childrenTitle: "",
            allPrice: 0,
            twoFromRules: {
                orderWay: [
                    {
                        required: true,
                        message: "请选择订餐方式",
                        trigger: "blur",
                    },
                ],
                orderStartTime: [
                    {
                        required: true,
                        message: "请选择订餐开始时间",
                        trigger: "change",
                    },
                ],
                orderType: [
                    {
                        required: true,
                        message: "请选择订餐类型",
                        trigger: "change",
                    },
                ],
                orderTimeOnec: [
                    {
                        required: true,
                        message: "请选择订餐日期",
                        trigger: "change",
                    },
                ],
                orderEndTime: [
                    {
                        required: true,
                        message: "请选择订餐结束时间",
                        trigger: "change",
                    },
                ],
                orderMoney: [
                    {
                        required: true,
                        message: "请输入订餐金额",
                        trigger: "blur",
                    },
                ],

                // ],
                // orderTimeOnec: [
                //   { required: true, message: "请选择订餐日期", trigger: "blur" },
                // ],

                // takeWay: [
                //   { required: true, message: "请选择取餐方式", trigger: "blur" },
                // ],
                // departmentId: [
                //   { required: true, message: "请选择部门", trigger: "change" },
                // ],
                // personId: [
                //   { required: true, message: "请选择送餐人员", trigger: "change" },
            },
            normalInfo: {},
            defaultProps: {
                children: "children",
                label: "label",
            },
            getUserInfo: {},
            orgList: [], //组织机构
            arrOrgList: [],
            orgLevels: "",
            // 新增模态框性别
            sexOptions: [
                {
                    value: "0",
                    label: "男",
                },
                {
                    value: "1",
                    label: "女",
                },
            ],
            // 表单验证
            addFormRules1: {
                customerName: [
                    { required: true, message: "请输入姓名", trigger: "blur" },
                ],
                // orgName: [
                //   {
                //     required: true,
                //     message: "请选择组织机构",
                //     trigger: "change",
                //   },
                // ],
                customerIdcard: [
                    {
                        required: true,
                        message: "请输入身份证号码",
                        trigger: "blur",
                    },
                    {
                        pattern:
                            /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
                        message: "证件号码格式有误！",
                        trigger: "blur",
                    },
                ],
            },
            // 新增模态框导航
            dialogTabs: ["基本信息", "订餐信息"],
            borderBotKey: 0,
            dialogBox: 0,
            infoVisivle: false,
            personVisible: false,
            personInfo: {},
            mapshow: false,
            // 订餐地址显示
            showad: false,
            // 新增模态框部门
            subsidyLevelOptions: [],
            // 餐补类型
            foodLevelOptions: [],
            // 送餐员
            personIdOptions: [],
            // 新增模态框
            addForm: {
                faceIdcode: "",
                orderWay: "0",
                orderTimeOnec: [],
                customerPolitical: "",
                photo: "",
                customerName: "",
                customerIdcard: "",
                customerBirthday: "",
                customerAge: "",
                customerSex: "",
                customerPhone: "",
                customerAddress: "",
                provinceId: "", //省
                cityid: "", //市
                zoneid: "", //区
                streetid: "", //街道
                shequid: "", //社区
                longitude: "", //经度
                latitude: "", //纬度
                address: "", //详细地址
                customerJzqk: "",
                economySource: [],
                serviceStation: "",
                orderStartTime: "",
                orderEndTime: "",
                orderType: [],
                orderMoney: "",
                totalMoney: "",
                takeWay: "",
                isAddress: "",
                subsidyBalance: "",
                totalMoney: "",
                customerPhoto: "",
            },
            orderType: [],
            // 所有图片名集合
            imgTitleList: ["photo"],
            provinceList: [], //省列表
            cityList: [], //市列表
            areaList: [], //区列表
            streetList: [], //街道列表
            communityList: [], //社区列表
            myMap: null,
            marker: null, //地图标记点
            polygons: [],
            isMap: true,
            // 民族
            nation: [
                "汉族",
                "蒙古族",
                "回族",
                "藏族",
                "维吾尔族",
                "苗族",
                "彝族",
                "壮族",
                "布依族",
                "朝鲜族",
                "满族",
                "侗族",
                "瑶族",
                "白族",
                "土家族",
                "哈尼族",
                "哈萨克族",
                "傣族",
                "黎族",
                "傈僳族",
                "佤族",
                "畲族",
                "高山族",
                "拉祜族",
                "水族",
                "东乡族",
                "纳西族",
                "景颇族",
                "柯尔克孜族",
                "土族",
                "达斡尔族",
                "仫佬族",
                "羌族",
                "布朗族",
                "撒拉族",
                "毛南族",
                "仡佬族",
                "锡伯族",
                "阿昌族",
                "普米族",
                "塔吉克族",
                "怒族",
                "乌孜别克族",
                "俄罗斯族",
                "鄂温克族",
                "德昂族",
                "保安族",
                "裕固族",
                "京族",
                "塔塔尔族",
                "独龙族",
                "鄂伦春族",
                "赫哲族",
                "门巴族",
                "珞巴族",
                "基诺族",
            ],
            // 图片地址
            actionUrl:
                baseURL + "/ypt/controller/uploadController/info/uploadPhoto",
            imageUrl: "",
            // 图片上传
            dialogImageUrl: "",
            photo: [],
        }
    },
    mounted() {
        const self = this
        let { title } = this.openData
        if (this.openData.title == "新增") {
            this.getProvince()
        } else {
            let params = {
                id: this.openData.id, //行ID
            }
            if (title == "查看") {
                this.$set(this, "addFormRules1", {})
                this.$set(this, "twoFromRules", {})
            }

            request({
                url: "/ypt/admin/order/findById",
                method: "POST",
                data: params,
            }).then(async (res) => {
                let { content } = res
                let { orderTimeOnec, orderType } = content
                this.addForm = {
                    ...content,
                    economySource: [],
                    orderType: orderType ? orderType.split(",") : [],
                }

                orderTimeOnec &&
                    (this.addForm.orderTimeOnec = orderTimeOnec
                        .replace(/^\[|\]$/g, "")
                        .split(","))
                request({
                    url: "/sqyl/admin/customer/info/findById",
                    method: "POST",
                    data: { id: content.customerId },
                }).then(async (res_) => {
                    let { economySource } = res_.content

                    console.log(res_.content, "res_.content")
                    console.log({ economySource }, "{ economySource }")
                    this.addForm = {
                        ...res_.content,
                        ...this.addForm,
                        economySource: economySource.split(""),
                    }
                    self.addForm.customerPhone = res_.content.customerPhone
                    self.addForm.customerIdcard = res_.content.customerIdcard
                    console.log(self.addForm.customerPhone)
                    console.log(this.addForm, "详情信息")
                    self.addForm.provinceId = String(self.addForm.provinceId)
                    self.addForm.customerAddress = self.addForm.address
                    self.addForm.longitude = self.addForm.addressLng
                    self.addForm.latitude = self.addForm.addressLat
                    self.addForm.cityid = String(self.addForm.cityid)
                    self.addForm.zoneid = String(self.addForm.zoneid)
                    self.addForm.streetid = String(self.addForm.streetId)
                    self.addForm.shequid = Number(self.addForm.shequid)
                    let provice = await self.getDistricts()
                    self.provinceList = provice.districtList
                    if (!self.addForm.provinceId) return
                    let city = await self.getDistricts(self.addForm.provinceId)
                    self.cityList = city.districtList
                    if (!self.addForm.cityid) return
                    let area = await self.getDistricts(self.addForm.cityid)
                    self.areaList = area.districtList
                    if (!self.addForm.zoneid) return
                    let street = await self.getStreetList(self.addForm.zoneid)
                    self.streetList = street
                    if (!self.addForm.streetid) return
                    let communityList = await self.getCommityList(
                        self.addForm.streetid
                    )
                    self.communityList = communityList
                    this.mapshow = false
                })
            })
        }

        this.getOrg()
        this.getOrgInfo()
        this.departmentlist()
    },
    methods: {
        groupCheck(val) {
            console.log(val)
        },
        getOrgInfo() {
            this.$http
                .request({
                    url: "/rbac/admin/org/info/findOrgById",
                    method: "POST",
                    data: { id: this.$store.state.info.orgId },
                })
                .then((res) => {
                    if (res.code == 200) {
                        // this.getProvince()
                        this.normalInfo = res.content
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        // 打点
        potintMap() {
            const self = this
            try {
                self.myMap.remove(self.marker)
            } catch (err) {
                console.log(err)
            }
            console.log(
                Number(this.addForm.longitude),
                Number(this.addForm.latitude),
                "坐标"
            )
            self.marker = new AMap.Marker({
                icon: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
                position: [
                    Number(this.addForm.longitude),
                    Number(this.addForm.latitude),
                ],
            })
            self.myMap.add(self.marker)
            self.myMap.setFitView()
        },
        //获取地址
        getDistricts(name = "中国", params = null) {
            let self = this
            return new Promise((resolve, reject) => {
                var opts = {
                    subdistrict: 1, //返回下一级行政区
                    extensions: "all",
                    showbiz: false, //最后一级返回街道信息
                }
                let district = new AMap.DistrictSearch(opts)
                let geocoder = new AMap.Geocoder({
                    city: "", //城市设为北京，默认：“全国”
                    radius: 1000, //范围，默认：500
                })
                try {
                    self.myMap.remove(self.marker)
                } catch (err) {
                    console.log(err)
                }

                self.marker = new AMap.Marker()
                district.search(name, (status, result) => {
                    if (status == "complete") {
                        resolve(result.districtList[0])
                        if (this.isMap) {
                            this.isMap = false
                            return
                        }
                        let bounds = result.districtList[0].boundaries
                        self.polygon = null
                    }
                })
            }).catch((err) => {
                console.log(err)
            })
        },
        // 部门列表
        async departmentlist() {
            let params = {
                pageNo: 1,
                pageSize: 10,
                webfrom: "1",
                qujiId: JSON.parse(localStorage.getItem("czUserInfo")).qujiId,
                shengjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shengjiId,
                shijiId: JSON.parse(localStorage.getItem("czUserInfo")).shijiId,
                stationId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .stationId,
                shequjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shequjiId,
            }
            params = Object.assign({}, params)
            await request({
                url: "/sqyl/admin/department/info/findList",
                method: "POST",
                data: params,
            }).then((res) => {
                // console.log(res);
                this.subsidyLevelOptions = res.content.list
            })
        },
        // 订餐地址显示
        showAddress() {
            if (this.addForm.takeWay == "0") {
                this.showad = true
            } else {
                this.showad = false
            }
        },

        //获取地址
        getDistrict(name = "中国", params = null) {
            let self = this
            return new Promise((resolve, reject) => {
                var opts = {
                    subdistrict: 1, //返回下一级行政区
                    extensions: "all",
                    showbiz: false, //最后一级返回街道信息
                }
                let district = new AMap.DistrictSearch(opts)
                let geocoder = new AMap.Geocoder({
                    city: "", //城市设为北京，默认：“全国”
                    radius: 1000, //范围，默认：500
                })
                try {
                    self.myMap && self.myMap.remove(self.marker)
                } catch (err) {
                    console.log(err)
                }
                self.marker = new AMap.Marker()
                district.search(name, (status, result) => {
                    if (status == "complete") {
                        resolve(result.districtList[0])
                        if (this.isMap) {
                            this.isMap = false
                            return
                        }
                        let bounds = result.districtList[0].boundaries
                        self.polygon = null
                        if (bounds) {
                            try {
                                self.myMap.remove(self.polygons)
                            } catch (error) {
                                console.log("移除地图编辑出错了")
                            }
                            self.polygons = []
                            for (let i = 0, l = bounds.length; i < l; i++) {
                                self.polygon = new AMap.Polygon({
                                    map: self.myMap,
                                    strokeWeight: 1,
                                    strokeColor: "#0091ea",
                                    fillColor: "#80d8ff",
                                    fillOpacity: 0.4,
                                    path: bounds[i],
                                })
                                self.polygons.push(self.polygon)
                                if (!params) {
                                    self.polygon.on("click", function (e) {
                                        let lnglat = e.lnglat
                                        self.myMap.add(self.marker)
                                        self.marker.setPosition(lnglat)
                                        geocoder.getAddress(
                                            lnglat,
                                            function (status, result) {
                                                if (
                                                    status === "complete" &&
                                                    result.regeocode
                                                ) {
                                                    var address =
                                                        result.regeocode
                                                            .formattedAddress
                                                    self.addForm.customerAddress =
                                                        address
                                                    self.addForm.longitude =
                                                        lnglat.lng
                                                    self.addForm.latitude =
                                                        lnglat.lat
                                                } else {
                                                    console.error(
                                                        "根据经纬度查询地址失败"
                                                    )
                                                }
                                            }
                                        )
                                    })
                                    self.myMap.add(self.polygons)
                                    self.myMap.setFitView() //地图自适应
                                } else {
                                    if (params.longitude && params.latitude) {
                                        self.myMap.add(self.marker)
                                        self.marker.setPosition([
                                            params.longitude,
                                            params.latitude,
                                        ])
                                        self.myMap.setFitView(self.marker)
                                        self.myMap.setZoom(11)
                                    }
                                }
                            }
                        }
                    }
                })
            }).catch((err) => {
                console.log(err)
            })
        },
        //获取省级
        async getProvince() {
            this.provinceLis = []
            this.cityList = []
            this.areaList = []
            this.streetList = []
            let province = await this.getDistrict()
            this.provinceList = province.districtList
        },

        //  省级地址选择发生改变
        async handleProvince(val) {
            this.cityList = []
            this.areaList = []
            this.streetList = []
            this.communityList = []
            this.addForm.cityid = ""
            this.addForm.zoneid = ""
            this.addForm.streetid = ""
            this.addForm.shequid = ""
            this.addForm.customerAddress = ""
            let city = await this.getDistrict(val)
            this.cityList = city.districtList
        },
        //市级地址发生改变
        async handleCity(val) {
            this.areaList = []
            this.streetList = []
            this.communityList = []
            this.addForm.zoneid = ""
            this.addForm.streetid = ""
            this.addForm.shequid = ""
            this.addForm.customerAddress = ""
            let area = await this.getDistrict(val)
            this.areaList = area.districtList
        },
        //县区级地址发生改变
        async handleArea(val) {
            this.streetList = []
            this.communityList = []
            this.addForm.streetid = ""
            this.addForm.shequid = ""
            this.addForm.customerAddress = ""
            // val = val.replace(/.$/, "");
            let street = await this.getStreetList(val)
            this.streetList = street
        },
        //街道地址发生变化
        async streetChange(val) {
            this.addForm.shequid = ""
            let communityList = await this.getCommityList(val)
            this.communityList = communityList
            this.joinAddress()
        },
        //街道地址列表
        getStreetList(val) {
            let self = this
            return new Promise((resolve, reject) => {
                self.$http
                    .request({
                        url: "/ypt/admin/addressYpe/info/findList",
                        method: "POST",
                        data: {
                            parentId: val,
                            pageNo: 1,
                            pageSize: -1,
                        },
                    })
                    .then((res) => {
                        if (res.code == 200) {
                            if (!res.content) {
                                resolve([])
                                return
                            }
                            this.streetList = res.content.list
                            resolve(res.content.list)
                        } else {
                            resolve([])
                        }
                    })
            }).catch((err) => {
                console.log(err)
            })
        },
        // 社区地址列表
        getCommityList(val) {
            let self = this
            return new Promise((resolve, reject) => {
                self.$http
                    .request({
                        url: "/ypt/admin/standardAddress/info/StandardAddressTree",
                        method: "POST",
                        data: {
                            jiedaoId: val,
                        },
                    })
                    .then((res) => {
                        if (res.code == 200) {
                            if (!res.content) {
                                resolve([])
                                return
                            }
                            resolve(res.content)
                        } else {
                            resolve([])
                        }
                    })
            }).catch((err) => {
                console.log(err)
            })
        },
        // 上传文件提示
        handleExceed(files, fileList) {
            this.$message.warning(
                `当前限制选择 1 个图片，本次选择了 ${
                    files.length
                } 个文件，共选择了 ${files.length + fileList.length} 个文件`
            )
        },
        // 预览图片
        handlePicturePreview(file) {
            this.dialogImageUrl = file.url
        },
        handleAvatarSuccess(res, file, name) {
            this.imageUrl = res.content
            this.addForm.customerPhoto = res.content
        },
        loopNode(node, arr) {
            if (node.parent == null) {
                return arr
            } else {
                arr.push(node.data.orgId)
                this.loopNode(node.parent, arr)
            }
        },
        // 组织机构节点
        handleEditNodeClick(data, node) {
            const clickNode = this.$refs.tree.getNode(node)
            const arr = []
            this.loopNode(clickNode, arr)
            this.arrOrgList = arr
            let obj = common.organization(
                this.arrOrgList,
                this.normalInfo.orgLevel
            )
            this.$set(this.addForm, "orgId", data.orgId)
            this.$set(this.addForm, "parentId", data.parentId)
            this.$set(this.addForm, "orgType", data.orgType)
            this.$set(this.addForm, "orgName", data.label)

            this.$set(this.addForm, "qujiId", obj.qujiId)
            this.$set(this.addForm, "shengjiId", obj.shengjiId)
            this.$set(this.addForm, "shijiId", obj.shijiId)
            this.$set(this.addForm, "stationId", obj.stationId)
            this.$set(this.addForm, "shequjiId", obj.shequjiId)
            this.$refs["selectBoxRef"].handleClose()
        },
        //获取组织机构
        getOrg() {
            this.$http
                .request({
                    url: "/rbac/admin/org/info/OrgTreelist",
                    method: "POST",
                    data: { isValid: 1 },
                })
                .then((res) => {
                    if (res.code == 200) {
                        for (let i in res.content) {
                            if (res.content[i].orgType == "1") {
                                this.orgList.push(res.content[i])
                            }
                        }
                    }
                })
        },
        // 搜索用户信息
        searchPerson(val) {
            let id = val
            if (val) {
                let params = {
                    pageNo: this.pageNo,
                    pageSize: this.pageSize,
                    customerIdcard: id,
                    qujiId: JSON.parse(localStorage.getItem("czUserInfo"))
                        .qujiId,
                    shengjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                        .shengjiId,
                    shijiId: JSON.parse(localStorage.getItem("czUserInfo"))
                        .shijiId,
                    stationId: JSON.parse(localStorage.getItem("czUserInfo"))
                        .stationId,
                    shequjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                        .shequjiId,
                }
                params = Object.assign({}, params)
                request({
                    url: "/sqyl/admin/customer/info/findList",
                    method: "POST",
                    data: params,
                }).then((res) => {
                    this.addForm = res.content.list[0]
                    this.addForm.economySource =
                        res.content.list[0].economySource.split(",")
                    this.addForm.orderType =
                        res.content.list[0].orderType.split(",")
                })
            }
            //出身年月
            var birthday = ""
            if (val != null && val != "") {
                if (val.length == 15) {
                    birthday = "19" + val.substr(6, 6)
                } else if (val.length == 18) {
                    birthday = val.substr(6, 8)
                }
                birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-")
            }
            this.addForm.customerBirthday = birthday
            // 性别
            if (val.length == 18) {
                if (val.charAt(16) % 2 == 0) {
                    this.addForm.customerSex = "1"
                } else {
                    this.addForm.customerSex = "0"
                }
            } else if (val.length == 15) {
                if (val.charAt(14) % 2 == 0) {
                    this.addForm.customerSex = "1"
                } else {
                    this.addForm.customerSex = "0"
                }
            } else {
                return ""
            }
        },
        //新增模态框导航样式选择事件
        selectDialogTabs(index) {
            this.borderBotKey = index
            this.dialogBox = index
        },
        // 取消
        cancleForm() {
            this.$emit("cancleOpen", "")
        },
        // 提交数据
        submitForm() {
            this.openData.title == "查看详情" && (this.openData.title = "新增")
            this.twoFromRules["orderMoney"][0].required = true //恢复金额必填项校验
            if (this.addForm.orderWay == 0) {
                this.addForm.orderTimeOnec = ""
            }
            this.$refs.addForm1.validate((valid1) => {
                if (valid1) {
                    this.$refs.addForm2.validate((valid2) => {
                        if (valid2) {
                            let obj = common.organization(
                                this.arrOrgList,
                                this.normalInfo.orgLevel
                            )
                            let params = null
                            this.addForm.orderTimeOnec = JSON.stringify(
                                this.addForm.orderTimeOnec
                            )
                            if (this.openData.title == "新增") {
                                params = {
                                    pageNo: this.pageNo,
                                    pageSize: this.pageSize,
                                    ...this.addForm,
                                    customerId: this.addForm.id,
                                    oldmanType: this.addForm.subsidyLevel,
                                    economySource:
                                        this.addForm.economySource + "",
                                    orderType: this.addForm.orderType.join(),
                                    qujiId: obj.qujiId,
                                    shengjiId: obj.shengjiId,
                                    shijiId: obj.shijiId,
                                    stationId: obj.stationId,
                                    shequjiId: obj.shequjiId,
                                    orgName: obj.orgName,
                                    orgId: obj.orgId,
                                    communityId: this.openData.socialOrgId,
                                }
                                delete params.id
                            } else {
                                params = {
                                    pageNo: this.pageNo,
                                    pageSize: this.pageSize,
                                    ...this.addForm,
                                    economySource:
                                        this.addForm.economySource + "",
                                    orderType: this.addForm.orderType.join(),
                                }
                            }
                            // delete params.id,
                            params = Object.assign({}, params)

                            if (
                                parseInt(this.addForm.orderMoney) >
                                parseInt(this.addForm.totalMoney)
                            ) {
                                this.$message({
                                    message: `余额不足，请充值`,
                                    type: "warning",
                                })
                            } else {
                                request({
                                    url: "/ypt/admin/order/insert",
                                    method: "POST",
                                    data: params,
                                }).then((res) => {
                                    delete params.id
                                    // console.log(res);
                                    if (res.code == 200) {
                                        this.$message({
                                            message: `新增订单成功`,
                                            type: "success",
                                        })
                                        this.showList()
                                    } else {
                                        this.$message({
                                            message: `新增订单失败`,
                                            type: "warning",
                                        })
                                    }
                                })
                            }
                        }
                    })
                }
            })
        },
        showList() {
            //提交成功后清空当前表单
            Array.from(Object.keys(this.addForm)).map((item) => {
                this.addForm[item] = ""
                if (item == "economySource" || item == "orderType") {
                    this.addForm[item] = []
                }
                item == "orderWay" &&
                    (this.addForm.orderWay.toString()
                        ? this.addForm.orderWay
                        : "0")
            })
            this.$parent.refresh()
        },
        // 取消人员记录
        canclePerson(data) {
            this.personVisible = false
            this.infoVisivle = false
            this.personInfo = {}
            if (data != "") {
            }
        },
        // 查看人员记录
        lookRY() {
            this.personVisible = true
            this.personInfo = Object.assign(this.openData, {
                personState: true,
            })
            this.infoVisivle = false
        },
        // 查看记录详情
        addVolunteer() {
            let { title } = this.openData
            if (title == "新增" || title == "编辑")
                this.twoFromRules["orderMoney"][0].required = false

            this.$refs["addForm2"].validate((valid) => {
                if (valid) {
                    this.infoVisivle = true
                    this.personVisible = false
                    this.childrenTitle = "查看详情"
                }
            })
        },
        // 取消查看记录
        cancleOrder() {
            this.infoVisivle = false
        },
        // 上传前
        beforeAvatarUpload(file) {
            const isJPG =
                file.type === "image/jpeg" || file.type === "image/png"
            const isLt2M = file.size / 1024 / 1024 < 2
            if (!isJPG) {
                this.$message.error("上传头像图片只能是 JPG 格式!")
                return
            }
            if (!isLt2M) {
                this.$message.error("上传头像图片大小不能超过 2MB!")
                return
            }
        },
        // 地图显示
        location() {
            if (this.addForm.customerName == "") {
                this.$message.error("请选择人")
            } else {
                this.mapshow = !this.mapshow
                if (this.mapshow == true) {
                    setTimeout(async () => {
                        await this.$nextTick(() => {
                            this.loadmap("container")
                            this.potintMap()
                        })
                    }, 30)
                }
            }
        },

        // 选择人员
        selectDepart(val) {
            let params = {
                departmentId: val,
                webfrom: "1",
                qujiId: JSON.parse(localStorage.getItem("czUserInfo")).qujiId,
                shengjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shengjiId,
                shijiId: JSON.parse(localStorage.getItem("czUserInfo")).shijiId,
                stationId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .stationId,
                shequjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shequjiId,
            }
            params = Object.assign({}, params)
            request({
                url: "/sqyl/admin/person/info/findPersonByDept",
                method: "POST",
                data: params,
            }).then((res) => {
                console.log(res)
                this.personIdOptions = res.content
            })
        },
        // 地图初始化
        loadmap(index) {
            let self = this
            return new Promise((resolve, reject) => {
                self.myMap = new AMap.Map(index, {
                    resizeEnable: true,
                    zoom: 18,
                })
                resolve()
            })
        },
        // 关闭
        handleClose() {
            this.$emit("cancleOpen", false)
        },
    },
    watch: {
        async getUserInfo(n, o) {
            const self = this
            if (n) {
                this.addForm = { ...this.addForm, ...n }
                self.addForm.provinceId = String(self.addForm.provinceId)
                self.addForm.customerAddress = self.addForm.address
                self.addForm.longitude = self.addForm.addressLng
                self.addForm.latitude = self.addForm.addressLat
                self.addForm.cityid = String(self.addForm.cityid)
                self.addForm.zoneid = String(self.addForm.zoneid)
                self.addForm.streetid = String(self.addForm.streetid)
                self.addForm.shequid = Number(self.addForm.shequid)
                let provice = await self.getDistricts()
                self.provinceList = provice.districtList
                if (!self.addForm.provinceId) return
                let city = await self.getDistricts(self.addForm.provinceId)
                self.cityList = city.districtList
                if (!self.addForm.cityid) return
                let area = await self.getDistricts(self.addForm.cityid)
                self.areaList = area.districtList
                if (!self.addForm.zoneid) return
                let street = await self.getStreetList(self.addForm.zoneid)
                self.streetList = street
                if (!self.addForm.streetid) return
                let communityList = await self.getCommityList(
                    self.addForm.streetid
                )
                self.communityList = communityList

                console.log(this.addForm, "000")
                this.personVisible = false
                this.mapshow = false
                // this.potintMap()
            }
        },
        "addForm.orderWay"(n, o) {
            n == 1 && this.$set(this.addForm, "orderEndTime", "")
            n == 1 && this.$set(this.addForm, "orderStartTime", "")
            n == 0 && this.$set(this.addForm, "orderTimeOnec", "")
        },
        allPrice(n, o) {
            this.$set(this.addForm, "orderMoney", n || 0)
        },
    },
}
</script>
<style lang='less' scoped>
// 新增功能模态框导航样式
.addFrom {
    .el-dialog__header {
        text-align: center;
    }

    .el-form-item__label {
        border: 1px solid #000;
    }

    .el-form-item {
        // dialog输入框居右对齐
        margin: 0;
        // 输入框
        input {
            height: 30px;
        }
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    /deep/ .el-upload--picture-card {
        width: 178px;
        height: 178px;
    }

    // 新增功能模态框tabs
    .addDialogTabs {
        width: 100%;
        display: flex;
        font-size: 14px;
        justify-content: space-between;

        .borderBot {
            border-bottom: 2px solid #169bd5;
        }

        /deep/ .el-dialog__body {
            padding-top: 0px !important;
        }

        /deep/ .el-dialog__footer {
            text-align: center;
        }
    }

    .addDialogTabs > div {
        cursor: pointer;
        font-size: 14px;
        width: 50%;
        height: 50px;
        display: flex;
        margin-bottom: 10px;
        justify-content: center;
        align-items: center;
        border-bottom: 2px solid #e4e4e4;
    }

    .dialogBody {
        display: flex;
        // width: 100%;
        .dialogBodyright {
            width: 100%;
        }
    }

    /deep/ .el-dialog {
        /deep/ .el-dialog__header {
            border-bottom: 1px solid #e6e6e6;
        }

        /deep/ .el-dialog__body {
            padding-top: 0px !important;
        }
    }

    /deep/ .imgdialog {
        /deep/ .el-dialog__body {
            padding-top: 10px !important;
        }
    }

    // 模态框居住情况
    .dialogLiveRadio {
        display: flex;
        align-items: center;
    }
}

// 弹框底部
/deep/ .el-dialog .el-dialog__footer {
    background-color: #f5f5f5;
}

.mb24 {
    margin-bottom: 24px;
}

/deep/ .el-form-item {
    margin: 30px;
}
</style>